import _ from 'lodash'
import { useEffect, useState } from 'react'
import CompanyConfigClient from '@vero/api-client-browser/clients/company-config.js'

export default function (setLoading, setError, handleError) {
  const [companies, setCompanies] = useState([])
  const companyConfigClient = new CompanyConfigClient()

  async function fetchCompanies (nextToken) {
    try {
      setError(null)
      setLoading(true)

      const { _links, results } = await companyConfigClient.list(nextToken)
      setCompanies(c => _.concat(c, results))

      const newNextToken = _.get(_links, 'next.next-token')
      if (newNextToken) {
        await fetchCompanies(newNextToken)
      }
    } catch (e) {
      await handleError(e)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchCompanies()
  }, [])

  return {
    companies
  }
}
